<template>
    <div class="flats-crm-items-container flats-items-list" v-if="flatsItems != null">
        <div class="flats-empty-msg" v-if="flatsEmptyMsg"><p>{{flatsPage.flats_cards_info.flat_not_found_msg}}</p></div>
        <div class="flat-cards-items-list-info" v-if="!flatsEmptyMsg && !mobileView">
            <ul>
                <div class="left">
                    <li><p>{{flatsPage.flats_cards_info.flat_plan_name}}</p></li>
                </div>
                <div class="center">
                    <li><p>{{flatsPage.flats_cards_info.flat_object_name}}</p></li>
                    <li><p>{{flatsPage.flats_cards_info.flat_rooms}}</p></li>
                    <li><p>{{flatsPage.flats_cards_info.flat_size}}</p></li>
                    <li><p>{{flatsPage.flats_cards_info.flat_price}} <span>м²</span></p></li>
                    <li><p>{{flatsPage.flats_cards_info.flat_floor}}</p></li>
                    <li><p>{{flatsPage.flats_cards_info.flat_flat_number}}</p></li>
                    <li><p>{{flatsPage.flats_cards_info.flat_bloom}}</p></li>
                </div>
                <div class="right">
                    <li><p>{{flatsPage.flats_cards_info.flat_you_can_name}}</p></li>
                </div>
            </ul>
        </div>
        <div class="flats-items-list-loop" v-if="!flatsEmptyMsg">
            <div class="flat-item" v-for="item in flatsItems" :key="item.id">
                <router-link :to="{ name: 'flat-crm-card' , params:{'id' : item.id}}" class="item-link" @click.native="startLoader">
                    <div class="mobile-project" v-if="isMobileChecker">
                        <p v-if="mobileView">Объект</p>
                        <div class="project" v-if="item.complexCode != 'LDM'">
                            {{item.complexName.replace(/['"]+/g, '')}}
                        </div>
                        <div class="project" v-else>
                            {{item.complexName.replace(/\,.*/,'')}}
                        </div>
                    </div>
                    <div class="item-default item-img" v-if="item != null && item.id != null">
                        <div class="img-in" v-if="item.images.length > 0">
                            <img :src="'https://bazis-online.kz/crmc/rest/prices/getImage?imageId=' + pic.id" v-for="(pic, index) in item.images.filter(item => item.typeCode === '1')" :key="index">
                        </div>
                    </div>
                    <div class="item-info">
                        <ul>
                            <li v-if="!isMobileChecker">
                                <!-- {{item.complexName.replace(/['"]+/g, '')}} -->
                                <div class="project" v-if="item.complexCode != 'LDM' && item.complexCode != 'LDM-II' && item.complexCode != 'LDM-III' && item.complexCode != 'LDM-IV' && item.complexCode != 'PVS' && item.complexCode != 'PVG' && item.complexCode != 'VSP' && item.complexCode != 'VSP1' && item.complexCode != 'VSP2'">
                                    {{item.complexName.replace(/['"]+/g, '')}}
                                </div>
                                <div class="project" v-else>
                                    {{item.complexName.replace(/\,.*/,'')}}
                                </div>
                                <p v-if="mobileView">{{flatsPage.flats_cards_info.flat_object_name}}</p>
                            </li>
                             <li>
                                {{item.rooms}}
                                <p v-if="mobileView">{{flatsPage.flats_cards_info.flat_rooms}}</p>
                            </li>
                            <li>
                                {{item.area}} <span>м²</span>
                                <p v-if="mobileView">{{flatsPage.flats_cards_info.flat_size}}</p>
                            </li>
                            <li class="price">
                                <strong v-if="item.showPricesOnSaleSite == true"><span>от</span> {{getNumber(item.meterPrice)}} <span v-if="!mobileView">тг.</span></strong>
                                <p v-if="mobileView">{{ flatsPage.flats_cards_info.flat_price }}<span>тг. м²</span></p>
                            </li>
                            <li>
                                {{item.floor}}
                                <p v-if="mobileView">{{flatsPage.flats_cards_info.flat_floor}}</p>
                            </li>
                            <li>
                                {{item.number}}
                                <p v-if="mobileView">{{flatsPage.flats_cards_info.flat_flat_number}}</p>
                            </li>
                            <li>
                                <!-- {{getNumbersOfString(item.blockName)}} -->
                                <div class="right" v-if="item.complexCode != 'DSV' && item.complexCode != 'LDM' && item.complexCode != 'LDM-II' && item.complexCode != 'LDM-III' && item.complexCode != 'LDM-IV' && item.complexCode != 'SOH' && item.complexCode != 'MNC'">
                                    {{getNumbersOfString(item.blockName)}}
                                </div>
                                <div class="right" v-if="item.complexCode == 'DSV' || item.complexCode == 'LDM' || item.complexCode == 'LDM-II' || item.complexCode == 'LDM-III' || item.complexCode == 'LDM-IV'">
                                    {{getNumbersOfBlockDiscovery(item.blockName)}}
                                </div>
                                <div class="right" v-if="item.complexCode == 'MNC'">
                                    {{ getNumbersOfBlockMonaco(item.blockName) }}
                                </div>
                                <div class="blockname" v-if="item.complexCode == 'SOH'">
                                    {{getNumbersOfBlockSoho(item.blockName)}}
                                </div>
                                <p v-if="mobileView && item.complexCode != 'SOH'">{{flatsPage.flats_cards_info.flat_bloom}}</p>
                                <p v-if="mobileView && item.complexCode == 'SOH'">{{flatsPage.flats_cards_info.flat_kvartal}}</p>
                            </li>
                        </ul>
                    </div>
                    <div class="item-btns">
                    <!-- {{complexData.project_name.slug }} -->
                        <!-- {{item.blockName}} -->
                        <!-- {{item.complexCode}} -->
                        <div>
                            <a 
                                :href="URLrocketLC + '/?apartment_id=' + item.id +'&method=book&lang=' + langVAR" class="bron" target="_blank" 
                                @click.prevent="linkToLogin(URLrocketLC + '/?apartment_id=' + item.id +'&method=book&lang=' + langVAR, 'book')"
                                v-if="item.isApartmentReserved"
                                >{{flatsPage.flats_cards_info.flat_btn_book_name}}
                            </a>
                            <span v-else class="btn-off bron-off">{{flatsPage.flats_cards_info.flat_btn_book_name}}</span>
                            <a 
                                :href="URLrocketLC + '/?apartment_id=' + item.id +'&method=by&lang=' + langVAR" class="by" target="_blank" 
                                @click.prevent="linkToLogin(URLrocketLC + '/?apartment_id=' + item.id +'&method=by&lang=' + langVAR, 'by')" 
                                v-if="item.hasJointVentureAgreement"
                                >{{flatsPage.flats_cards_info.flat_btn_by_name}}
                            </a>
                            <span v-else class="btn-off by-off">{{flatsPage.flats_cards_info.flat_btn_by_name}}</span>
                        </div>
                        <!-- <div v-else>
                            <a 
                                :href="URLrocketLC + '/?apartment_id=' + item.id +'&method=book&lang=' + langVAR" class="bron" target="_blank" 
                                @click.prevent="linkToLogin(URLrocketLC + '/?apartment_id=' + item.id +'&method=book&lang=' + langVAR, 'book')"
                                v-if="checkConfirmPurchase('book', item.complexCode, item.blockName)"
                                >{{flatsPage.flats_cards_info.flat_btn_book_name}}
                            </a>
                            <span v-else class="btn-off bron-off">{{flatsPage.flats_cards_info.flat_btn_book_name}}</span>
                            <a 
                                :href="URLrocketLC + '/?apartment_id=' + item.id +'&method=by&lang=' + langVAR" class="by" target="_blank" 
                                @click.prevent="linkToLogin(URLrocketLC + '/?apartment_id=' + item.id +'&method=by&lang=' + langVAR, 'by')" 
                                v-if="checkConfirmPurchase('by', item.complexCode, item.blockName)"
                                >{{flatsPage.flats_cards_info.flat_btn_by_name}}
                            </a>
                            <span v-else class="btn-off by-off">{{flatsPage.flats_cards_info.flat_btn_by_name}}</span>
                        </div> -->
                        <div class="hypothec-btn" :class="{'disabled-link' : !item.hasMortgage}">
                            <router-link :to="{ name: 'flat-crm-card' , params:{'id' : item.id}, hash: '#flat-crm-card-online-payment'}" v-if="item.hasMortgage">{{ flatsPage.flats_cards_info.flat_btn_hypothec_name }}</router-link>
                            <span v-else class="btn-off">{{ flatsPage.flats_cards_info.flat_btn_hypothec_name }}</span>
                        </div>
                    </div>
                </router-link>

                <div class="btns-active" v-if="!isMobileChecker">
                    <div class="btn-item btn-to-favorite">
                        <a href="#" class="favorite-link btn-link" @click.prevent="sendToFavorite(item.id), checkerClass($event)" :class="{'active' : checkProjectFavorite(item.id)}">
                            <!-- <svgIcon name="star" class="icon-star"/> -->
                            <svgIcon name="star-sales" class="icon-star"/>
                        </a>
                    </div>
                    <div class="btn-item btn-to-compare">
                        <a href="#" class="compare-link btn-link" @click.prevent="sendToCompare(item.id), checkerClass($event)" :class="{'active' : checkProjectCompare(item.id)}">
                            <svgIcon name="ab" class="icon-ab"/>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import svgIcon from '@/components/partials/SvgIcon.vue';
    import {mapGetters} from 'vuex'
    export default {
        name: 'flats-items-list',
        props: ['mobileView'],
        components: {
            svgIcon,
        },
        data () {
            return {
                langVAR: window.LangVar,
            }
        },
        computed: mapGetters({
            // salesCard: 'loadSalesCardContent',
            // salesCardPage: 'loadSalesCardPage',
            flatsPage: 'loadFlatsPage',
            flatsItems: 'loadFlatsItems',
            flatsEmptyMsg: 'loadFlatsEmptyMsg',
            ucoCRMurl: 'loadUrlCRMuco',
            URLrocketLC: 'loadUrlRocketLC',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            getNumbersOfString(str) {
                return str.replace(/[^0-9]+/g, "");
            },
            getNumbersOfBlockDiscovery(str) { 
                var parseStr = str.split(',')[0];
                return parseStr.replace('Пятно', '');
            },
            getNumbersOfBlockLandmark(str) {
                var parseStr = str.split(',')[0];
                return parseStr.replace('Пятно', '');
            },
            getNumbersOfBlockSoho(str) {
                var parseStr = str.split(',')[0];
                return parseStr.replace('Квартал', '').replace(/ /g, '');
            },
            getNumbersOfBlockMonaco(str) {
                var parseStr = str.split(',')[0];
                return parseStr.replace('Пятно', '').replace(/ /g, '');
            },
            getNumber(n) {
                return String(n).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.")
            },
            getBlockPartLDM(str) {
                var blockPart;
                blockPart = str.split(',')[1];
                blockPart = parseInt(blockPart);
                return blockPart;
            },
            getBlockPartSOH(str) {
                var blockPart;
                blockPart = str.split(',')[1];
                blockPart = blockPart.replace('Блок', '');
                blockPart = blockPart.replace(/ /g, '');
                return blockPart;
            },
            getBlockPartMNC(str) {
                var blockPart;
                blockPart = str.split(',')[1];
                blockPart = blockPart.replace('Блок', '');
                blockPart = blockPart.replace(/ /g, '');
                return blockPart;
            },
            openCrmFlatModal(arr) {
                this.$store.commit('modalData', arr);
                setTimeout(() => {
                    this.$modal.show('sales_land_flat_card_crm_modal');
                }, 300);
            },
            getPriceForm() {

            },
            startLoader() {
                this.$parent.$refs.topProgress.start();
            },
            openFormModal(param) {
                this.$store.commit('Open_Form_Modal', param);
            },

            sendToFavorite(id) { // Добавление квартиры в избранное
                // console.log(id, 'arr flat favorite', localStorage.getItem('favorite_flats'));
                // Получаем уже хранившиеся квартиры если есть из LocalStorage
                var exist = localStorage.getItem('favorite_flats');
                exist = exist ? exist.split(',') : [];
                // Проверяем есть ли уже такая квартира в Storage
                var finder = exist.find(item => item == id);
                // console.log(finder, 'НАЛИЧИЕ');

                if (finder == undefined) {
                    exist.push(id);
                    localStorage.setItem('favorite_flats', exist);
                    // this.$store.commit('setFavoriteCount', exist.length);
                    // console.log(exist);
                } else {
                    var filterExist = exist.filter(item => {
                        return item != id
                    })
                    localStorage.setItem('favorite_flats', filterExist);
                    // this.$store.commit('setFavoriteCount', filterExist.length);
                    // console.log(exist);
                }
            },
            checkProjectFavorite(id) {
                var items = localStorage.getItem('favorite_flats');
                items = items ? items.split(',') : [];
                // this.$store.commit('setFavoriteCount', items.length);
                var finder = items.find(item => item == id);
                // console.log(finder)
                if (finder != undefined) {
                    return true
                } else {
                    return false
                }
            },
            sendToCompare(id) { // Добавление квартиры в сравнение
                // console.log(id, 'arr flat favorite', localStorage.getItem('favorite_flats'));
                // Получаем уже хранившиеся квартиры если есть из LocalStorage
                var exist = localStorage.getItem('sales_compare_flats');
                exist = exist ? exist.split(',') : [];
                // Проверяем есть ли уже такая квартира в Storage
                var finder = exist.find(item => item == id);
                // console.log(finder, 'НАЛИЧИЕ');
                if (finder == undefined) {
                    exist.push(id);
                    localStorage.setItem('sales_compare_flats', exist);
                    // this.$store.commit('setFavoriteCount', exist.length);
                    // console.log(exist);
                } else {
                    var filterExist = exist.filter(item => {
                        return item != id
                    })
                    localStorage.setItem('sales_compare_flats', filterExist);
                    // this.$store.commit('setFavoriteCount', filterExist.length);
                    // console.log(exist);
                }
            },
            checkProjectCompare(id) {
                var items = localStorage.getItem('sales_compare_flats');
                items = items ? items.split(',') : [];
                // this.$store.commit('setFavoriteCount', items.length);
                var finder = items.find(item => item == id);
                // console.log(finder)
                if (finder != undefined) {
                    return true
                } else {
                    return false
                }
            },
            checkerClass(event) {
                event.currentTarget.classList.toggle('active');
            },
            linkToLogin(url, method) {
                // console.log(url);
                var exist = localStorage.getItem('favorite_flats');
                exist = exist ? exist.split(',') : [];
                // var url = 'https://bazis-a.rocketfirm.net';
                if (method == 'book') {
                    ym(57579163,'reachGoal','flat_book_item');
                } else if (method == 'by') {
                    ym(57579163,'reachGoal','flat_by_item')
                }
                var favoriteUrl;
                if (exist.length > 0) {
                    favoriteUrl = '&favoritesFlats=' + exist.join(',');
                    // console.log(exist, favoriteUrl);
                    window.open(
                        url + favoriteUrl,
                        '_blank'
                    );
                } else {
                    window.open(
                        url,
                        '_blank'
                    );
                }
            },
            checkConfirmPurchase(param, code, blockName) {
                // console.log(param, code, blockName)
                var blockNameBparse = blockName;
                if (code != 'DSV' && code != 'LDM' && code != 'SOH' && code != 'MNC') {
                    blockName = this.getNumbersOfString(blockName);
                } else if (code == 'DSV') { 
                    blockName = parseInt(this.getNumbersOfBlockDiscovery(blockName));
                } else if (code == 'LDM') {
                    blockName = parseInt(this.getNumbersOfBlockLandmark(blockName));
                } else if (code == 'SOH') {
                    blockName = this.getNumbersOfBlockSoho(blockName);
                } else if (code == 'MNC') {
                    blockName = this.getNumbersOfBlockMonaco(blockName);
                }
                // console.log(blockName, blockNameBparse)

                if (param == 'book') {
                    if (code == 'AKV') { // Настройка кнопок Акварель
                        if (blockName == '25' || blockName == '26' || blockName == '27' || blockName == '28') {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (code == 'RPR') { // Настройка кнопок Remizovka
                        if (blockName == '12' || blockName == '15' || blockName == '17') {
                            return true;
                        } else {
                            return false;
                        }
                    }
                    // ASTANA
                    else if (code == 'DSV') { // Настройка кнопок Discovery
                        if (blockName == '4') {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (code == 'LDM') { // Настройка кнопок Landmark
                        // console.log(this.blockPart, this.getBlockPartLDM(blockNameBparse), 'asdasdasdasd213123123123123')
                        if (this.getBlockPartLDM(blockNameBparse) == 3) {
                            if (blockName == '1') {
                                return true;
                            } else {
                                return false;
                            }
                        } else if (this.getBlockPartLDM(blockNameBparse) == 4) {
                            if (blockName == '1' || blockName == '2' || blockName == '3') {
                                return true;
                            } else {
                                return false;
                            }
                        }
                        
                    } else if (code == 'SOH') { // Настройка кнопок Soho
                        if (blockName == '2A') {
                            if (this.getBlockPartSOH(blockNameBparse) == 'А1' || this.getBlockPartSOH(blockNameBparse) == 'А2' || this.getBlockPartSOH(blockNameBparse) == 'А3' || this.getBlockPartSOH(blockNameBparse) == 'А4' || this.getBlockPartSOH(blockNameBparse) == 'А5' || this.getBlockPartSOH(blockNameBparse) == 'А6' || this.getBlockPartSOH(blockNameBparse) == 'А7' || this.getBlockPartSOH(blockNameBparse) == 'А8' || this.getBlockPartSOH(blockNameBparse) == 'А9') {
                                return true;
                            } else {
                                return false;
                            }
                        } else if (blockName == '2А') {
                            if (this.getBlockPartSOH(blockNameBparse) == 'А1' || this.getBlockPartSOH(blockNameBparse) == 'А2' || this.getBlockPartSOH(blockNameBparse) == 'А3' || this.getBlockPartSOH(blockNameBparse) == 'А4' || this.getBlockPartSOH(blockNameBparse) == 'А5' || this.getBlockPartSOH(blockNameBparse) == 'А6' || this.getBlockPartSOH(blockNameBparse) == 'А7' || this.getBlockPartSOH(blockNameBparse) == 'А8' || this.getBlockPartSOH(blockNameBparse) == 'А9') {
                                return true;
                            } else {
                                return false;
                            }
                        }
                    } 
                } else if (param == 'by') {
                    // ALMATY
                    if (code == 'AKV') { // Настройка кнопок Акварель
                        if (blockName == '25' || blockName == '26' || blockName == '27' || blockName == '28') {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (code == 'PRV') { // Настройка кнопок Primavera
                        if (blockName == '1' || blockName == '2') {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (code == 'RPR') { // Настройка кнопок Remizovka
                        return false;
                    }
                    // ASTANA
                    else if (code == 'DSV') { // Настройка кнопок Discovery
                        if (blockName == '4') {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (code == 'LDM') { // Настройка кнопок Landmark
                        // console.log(this.blockPart, 'asdasdasdasdasd')
                        if (this.getBlockPartLDM(blockNameBparse) == 4) {
                            if (blockName == '1' || blockName == '2' || blockName == '3') {
                                return true;
                            } else {
                                return false;
                            }
                        }
                    } else if (code == 'SOH') { // Настройка кнопок Soho
                        if (blockName == '2A') {
                            if (this.getBlockPartSOH(blockNameBparse) == 'А1' || this.getBlockPartSOH(blockNameBparse) == 'А2' || this.getBlockPartSOH(blockNameBparse) == 'А3' || this.getBlockPartSOH(blockNameBparse) == 'А4' || this.getBlockPartSOH(blockNameBparse) == 'А5' || this.getBlockPartSOH(blockNameBparse) == 'А6' || this.getBlockPartSOH(blockNameBparse) == 'А7' || this.getBlockPartSOH(blockNameBparse) == 'А8' || this.getBlockPartSOH(blockNameBparse) == 'А9') {
                                return true;
                            } else {
                                return false;
                            }
                        } else if (blockName == '2А') {
                            if (this.getBlockPartSOH(blockNameBparse) == 'А1' || this.getBlockPartSOH(blockNameBparse) == 'А2' || this.getBlockPartSOH(blockNameBparse) == 'А3' || this.getBlockPartSOH(blockNameBparse) == 'А4' || this.getBlockPartSOH(blockNameBparse) == 'А5' || this.getBlockPartSOH(blockNameBparse) == 'А6' || this.getBlockPartSOH(blockNameBparse) == 'А7' || this.getBlockPartSOH(blockNameBparse) == 'А8' || this.getBlockPartSOH(blockNameBparse) == 'А9') {
                                return true;
                            } else {
                                return false;
                            }
                        }
                    }
                } else {
                    return false;
                }
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/flats-crm/flats-crm-items-list.scss';
    @import '@/styles/components/flats-crm/flats-crm-items-main.scss';
    @import '@/styles/components/flats-crm/respond/flats-crm-items-list-respond.scss';
    @import '@/styles/components/flats-crm/respond/flats-crm-items-main-respond.scss';
    // @import '@/styles/components/flats-page/respond/flats-item-respond.scss';
</style>